import React from "react";
import {
  MimaButton,
  MimaDropZone,
  MimaInput,
  MimaPaginatedDropdown,
  MimaText,
  MimaTextArea,
  Modal,
} from "../../components";
import { Formik } from "formik";

const CreateSupport = ({ closeModal, onSubmit, validationSchema, loading }) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={4}>
        Create Ticket
      </MimaText>

      <Formik
        initialValues={{
          name: "",
          title: "",
          message: "",
          user: "",
          files: [],
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleBlur,
          handleChange,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <>
            <MimaPaginatedDropdown
              type="text"
              name="name"
              id="name"
              value={values.name}
              queryKey={["getAllSignedBusinesses"]}
              optionLabel="tradingName"
              labelTitle="Select Business"
              placeholder="Select Business"
              touched={touched?.name}
              error={errors?.name}
              url="/businesses"
              getPageValue={(page) => page?.data?.businesses || []}
              getPageTotalCount={(lastPage) => lastPage?.data?.count || 0}
              onChange={(data) => {
                setFieldValue("user", data._id);
                setFieldValue("name", data.tradingName);
                //   setFilterQuery(data._id);
              }}
              // width={38}
            />

            <MimaInput
              labelTitle="Title"
              placeholder="Enter Title"
              name="title"
              value={values.title}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.title}
              touched={touched.title}
            />
            <MimaTextArea
              labelTitle="Description"
              placeholder="Enter Description"
              name="message"
              value={values.message}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.message}
              touched={touched.message}
            />
            <div style={{ width: "38rem" }}>
              <MimaDropZone
                title="Upload Attachments"
                info="maximum Size 1MB"
                maxNumOfImages={1}
                files={values.files}
                setFiles={(newFiles) => {
                  setFieldValue("files", newFiles);
                }}
                labelTitle="Upload Attachments"
                name="files"
              />
            </div>
            <MimaButton
              title="Add"
              width={38}
              mt={2}
              buttonColor="var(--color-dark-4)"
              onClick={handleSubmit}
              loading={loading}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};
export default CreateSupport;
